import { useState, useRef, useEffect } from "react";
import { ReactComponent as ExpandIcon } from "../../../../assets/icons/expandDown.icon.svg";
import { ReactComponent as SearchIcon } from "../../../../assets/icons/search.icon.svg";
import { Link } from "react-router-dom";

const DEFAULT_CLASSNAMES = {
  td: "w-full",
};
const DEFAULT_OPTIONS = [{ value: "default", label: "DEFAULT" }];

const TableMultiSelectInput = ({
  options = DEFAULT_OPTIONS,
  classNames = DEFAULT_CLASSNAMES,
  label,
  value,
  childValue = "id",
  searchValue = "name",
  onChange,
  parentId,
  name,
  link = { href: "", identifier: "", target: "_blank", active: false },
  handleSearch = () => {},
  search = false,
  otherProps,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ref]);

  return (
    <td className={classNames.td}>
      <div
        tabIndex={0}
        ref={ref}
        className="font-ubuntuMedium bg-white shadow rounded outline-none gap-[.5em] p-[.2em] flex items-center focus:border focus:shadow-primary relative min-h-[1.5em]"
      >
        <span className="flex flex-wrap gap-1 grow">
          {!!value?.length &&
            value?.[0]?.[childValue] &&
            value?.map((v) => (
              <div
                key={v?.id}
                className=" bg-secondary text-white rounded px-2 py-1 flex gap-2 items-center"
              >
                {link?.active && (
                  <Link
                    to={`${link?.href}/${v?.[link?.identifier]}`}
                    target={link?.target}
                    className="hover:text-primary hover:underline decoration-primary"
                  >
                    {v?.[childValue]}
                  </Link>
                )}
                {!link?.active && <span>{v?.[childValue]}</span>}
                {search ? (
                  <SearchIcon
                    onClick={() => handleSearch(v?.[searchValue])}
                    className="flex fill-secondary top-[-4px] right-3 bg-greenGlass hover:bg-primary rounded p-1 cursor-pointer shadow-sm shadow-black backdrop-blur-sm"
                  />
                ) : null}
                <span
                  data-parent_id={parentId}
                  data-id={v?.id}
                  data-name={name}
                  onClick={onChange}
                  className="cursor-pointer hover:text-primary active:translate-x-px active:translate-y-px text-red-500 font-ubuntuBold px-0"
                >
                  &times;
                </span>
              </div>
            ))}
        </span>
        <button
          data-parent_id={parentId}
          data-name={name}
          data-reset={true}
          onClick={onChange}
          className="active:translate-x-px active:translate-y-px hover:text-red-500 font-ubuntuBold rounded p-0"
        >
          &times;
        </button>
        <div className="self-stretch w-[.05em] bg-stone-500"></div>
        <div>
          <ExpandIcon
            onClick={() => setIsOpen(!isOpen)}
            className="cursor-pointer flex items-center hover:fill-primary min-w-4 min-h-4 w-6 h-4"
          />
        </div>
        <ul
          style={{ top: "calc(100% + .25em)" }}
          className={`${
            isOpen ? "" : "hidden"
          } shadow-lg z-20 px-1 bg-greenGlass absolute left-0 w-full rounded m-0 p-0 list-none max-h-[15em] overflow-y-auto`}
        >
          {options.map((option) => (
            <li
              key={option?.id}
              data-id={option?.id}
              data-parent_id={parentId}
              data-ticket={option?.ticket}
              data-ticket_id={option?.ticket_id}
              data-description={option?.description}
              data-name={name}
              onClick={onChange}
              className={`${
                value?.find((v) => v?.id === option?.id)
                  ? "bg-secondary text-white"
                  : "bg-white"
              } shadow m-1 cursor-pointer hover:bg-primary hover:text-secondary rounded px-2 py-1`}
            >
              {option?.label}
            </li>
          ))}
        </ul>
      </div>
    </td>
  );
};

export default TableMultiSelectInput;
